import { BubbleFormPage } from '@go-client/components/BubbleUI/BubbleForm';
import SelectEventPage from '@go-client/components/ReservationPath/Pages/SelectEventPage';
import { ReservationWorkflowPrereqs, ResPathDataBundle } from '../ReservationPath';
import React from 'react';
import EnterReservationPage from '../Pages/EnterReservationPage';
import { NewReservation } from '@go-shared/types/reservation';
import { create } from '@go-client/lib/api/reservation';

export default function buildCreateReservationWorkflow(
  pages: Array<BubbleFormPage<ResPathDataBundle>>,
  preqs: ReservationWorkflowPrereqs
) {
  async function handleSubmitReservationForm() {
    preqs.setIsBusy(true);

    try {
      const toSubmit = (await preqs.formik.submitForm()) as unknown as NewReservation;
      if (!toSubmit) {
        throw new Error('No reservation data to submit');
      }

      const newSchedule = await create(toSubmit);

      preqs.onRefreshReservation?.(newSchedule);
    } finally {
      preqs.setIsBusy(false);
    }
  }

  pages.push({
    key: 'edit-page-1',
    render: actions => (
      <SelectEventPage
        title="Add Reservation"
        isBusy={preqs.isBusy}
        setIsBusy={preqs.setIsBusy}
        selectedEventSnapshot={preqs.selectedEventSnapshot}
        setSelectedEventSnapshot={preqs.setSelectedEventSnapshot}
        onGoForward={actions.goForward}
        forwardTitle="Next: Enter Reservation Details"
        onClose={preqs.onClose}
      />
    ),
  });

  pages.push({
    key: 'edit-page-2',
    render: (actions, res) =>
      res &&
      preqs.selectedEventSnapshot && (
        <EnterReservationPage
          formik={preqs.formik}
          title="Add Reservation"
          forwardTitle="Finish: Add Reservation"
          mode={preqs.mode}
          users={res.users}
          isBusy={preqs.isBusy}
          setIsBusy={preqs.setIsBusy}
          selectedEventSnapshot={preqs.selectedEventSnapshot}
          onGoBack={preqs.mode.edit ? undefined : actions.goBack}
          onClose={preqs.onClose}
          onSubmitReservationForm={handleSubmitReservationForm}
        />
      ),
  });
}
